import React, {useEffect} from "react";
import { useNavigate } from 'react-router-dom';
import { notification } from 'antd';
import axios from 'axios';
import {useStore} from './store';
import LayoutLogin from "../loginLayout";
import AllRoutes from "../routes";
import API_URL from '../config';

const baseURL = API_URL;

const Auth = ({children}) => {

    const { state, dispatch } = useStore();
    const navigate = useNavigate();

    useEffect(() => {
        if (!state.user) return;

        const reqInterceptor = axios.interceptors.request.use(function (config) {
            config.withCredentials = true;
            config.baseURL = baseURL;
            config.headers.Authorization = `Bearer ${state.user.token}`;
            config.headers.ContentType = 'application/x-www-form-urlencoded';
            return config;
        }, function (error) {
            return Promise.reject(error);
        });

        const resInterceptor = axios.interceptors.response.use(function (response) {
            return response;
        }, function (error) {
            const status = error?.response?.status;
            const message = error?.response?.data?.message;

            if (status === 401) {
                localStorage.removeItem('user');
                localStorage.removeItem('menu');
                dispatch({ type: 'SET_USER_DATA', payload: { user: null, menu: null } });
                navigate('/login');
                return Promise.reject(error);
            }

            if (message === 'unauthorized') {
                notification.open({
                    message: '! Yetki',
                    description: 'You are not authorized to view this data',
                });
            }
            return Promise.reject(error);
        });

        return () => {
            axios.interceptors.request.eject(reqInterceptor);
            axios.interceptors.response.eject(resInterceptor);
        };
    }, [state.user]);

    if (state.user) {
        return children;
    }

    return <LayoutLogin body={<AllRoutes />}/>;
}

export default Auth;
